import React from 'react';
import Modal from 'components/UI/Modal';
import { alert } from 'util/alert';
import ModalContent from "./ModalContent";
import { confirmable } from 'react-confirm';
import updateClockTime from 'controllers/teacher/updateClockTime'
import addClockTime from 'controllers/teacher/addClockTime'
import moment from 'moment'
import locale from './locale';
import "./Modal.scss";

class ModalBody extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      clockData: props.data.id ? props.data : {teacher: props.data.teacher}
    }

    this.onChange = this.onChange.bind(this)
  }

  componentDidMount(){

  }

  onChange(value){
    this.setState({clockData: value})
  }

  filterDataBeforeSubmit(){
    const schoolId = localStorage.getItem('schoolId')
    const {clockData} = this.state
    const {mode, proceed} = this.props

    const validateResult = this.validate();
    if (!validateResult.ok) {
      return;
    }

    if(mode === 'create'){
      addClockTime(schoolId, clockData)
      .then((res) => {
        if(res.reason === 'it is an future punch'){
          alert.warning(__('Cannot Clock In in Advance', locale)).then(() => {})
        } else {
          proceed(res)
        }
      })
      .catch((err) => {console.log(err)})
    } else if (mode === 'update'){
      let dataToSubmit = {
        teacher: clockData.teacher,
        operation_type: clockData.operation_type,
        punched_at: moment(clockData.punched_at).format('YYYY-MM-DD HH:mm'),
        note: clockData.note, 
      }
      let clockId = clockData.id

      updateClockTime(schoolId, clockId, dataToSubmit)
      .then((res) => {
        if(res.reason === 'it is an future punch'){
          alert.warning(__('Cannot Clock In in Advance', locale)).then(() => {})
        } else {
          proceed(res)
        }
      })
      .catch((err) => {console.log(err)})
    }
    
  }

	render() {
		const {show, proceed, dismiss, cancel} = this.props;
    const {clockData} = this.state

		return (
      <Modal
				className='clockInOut-modal'
				hasHeader={true}
        hasFooter={true}
				headerTitle={__("Clock In/Out", locale)}
        fixedWidth={500}
        contentHeight={460}
        onCloseModalClick={proceed}
        footerType="grey"
        footerButtons={[
          {
            title: __('Save', locale),
            className: 'btn btn-primary pull-right',
            onClick: ()=>{
              this.filterDataBeforeSubmit()
            }
          },
          {
            title: __('Cancel', locale),
            className: 'btn btn-default pull-right',
            onClick: ()=>{
              this.props.proceed()
            }
          }
        ]}
        isShowingModal={show} >
        <ModalContent
          {...this.props}
          clockData={clockData}
          onChange={this.onChange}
          onFormChange={(stateFromModalContent)=>{ this.formData = stateFromModalContent }}
          getValidationRef={(fn)=>{
            this.validate = fn;
          }}
         />
			</Modal>
    );
  }
}

export default confirmable(ModalBody);



// WEBPACK FOOTER //
// ./src/template/Modals/ClockInOut/ModalBody.js